module.exports = __webpack_public_path__ + "img/103.5b4f2e3a.svg";